import React, { memo } from 'react'
import {
  BWText,
  BWInput,
  BWPanelContent,
  requiredRule
} from 'src/libs/qb-brand-web-components'

import { ACCOUNT_PROFILE_DISPATCH } from '../../store/reducers/account/account'
import Button from '../shared/button/Button'
import Panel from '../shared/panel/Panel'
import { fetchCountriesByRegion } from '../../util/country.helpers'
import customConfig from 'customConfig'

const ChangeCountry = ({
  onFormSubmit,
  dispatchAction,
  accountProfile: { error, success, countryTemp },
  t
}) => {
  return (
    <Panel onFormSubmit={onFormSubmit} as='form'>
      <BWPanelContent>
        <BWText
          label={t('country-settings.country')}
          size={18}
          weight={700}
          alignCenter
        />
        <BWText label={t(customConfig.countrySettingsDescLabel)} alignCenter />
        <BWInput
          isDropdown
          options={fetchCountriesByRegion()}
          error={t(error[ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP])}
          success={t(success[ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP])}
          value={countryTemp}
          validate={[requiredRule]}
          onChange={(value) =>
            dispatchAction(ACCOUNT_PROFILE_DISPATCH.COUNTRY_TEMP, value)
          }
        />
      </BWPanelContent>
      <Button label={t('common.save')} type='submit' />
    </Panel>
  )
}

export default memo(ChangeCountry)
